<div class="cv__ai-actions">
  <button
    class="cv__ai-btn"
    [class.cv__ai-btn--done]="responseCopied()"
    title="Copy markdown response"
    (click)="copyResponse()"
  >
    @if (responseCopied()) {
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    } @else {
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
      </svg>
    }
  </button>
  <div class="cv__ai-sep"></div>
  <button
    class="cv__ai-btn"
    [class.cv__ai-btn--active]="feedbackPanelState()?.type === 'up'"
    title="Good response"
    (click)="handleFeedbackClick('up')"
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3z" />
      <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
    </svg>
  </button>
  <button
    class="cv__ai-btn"
    [class.cv__ai-btn--down]="feedbackPanelState()?.type === 'down'"
    title="Bad response"
    (click)="handleFeedbackClick('down')"
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3z" />
      <path d="M17 2h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
    </svg>
  </button>
</div>
@if (feedbackPanelState(); as fpState) {
  <div class="cv__feedback-panel">
    @if (fpState.type === 'success') {
      <div class="cv__feedback-status cv__feedback-status--ok">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
        Thank you for your detailed feedback.
      </div>
      <button class="cv__feedback-x" (click)="closeFeedbackPanel()">
        <svg
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    } @else if (fpState.type === 'error') {
      <div class="cv__feedback-status cv__feedback-status--err">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="15" y1="9" x2="9" y2="15" />
          <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
        Sorry, something went wrong.
      </div>
      <button class="cv__feedback-x" (click)="closeFeedbackPanel()">
        <svg
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    } @else {
      <div class="cv__feedback-header">
        <span>{{
          fpState.type === 'up'
            ? 'What did you like about this response? Your feedback keeps us on the right track'
            : 'What did you not like about this response? Your feedback will help us do better next time.'
        }}</span>
        <button class="cv__feedback-x" (click)="closeFeedbackPanel()">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="cv__feedback-chips">
        @for (chip of feedbackChips(fpState.type); track chip) {
          <button
            class="cv__feedback-chip"
            [class.cv__feedback-chip--selected]="fpState.selectedChips.includes(chip)"
            (click)="selectFeedbackChip(chip)"
          >
            {{ chip }}
          </button>
        }
      </div>
      <div class="cv__feedback-input-row">
        <textarea
          name="feedback input"
          class="cv__feedback-textarea"
          placeholder="Input text"
          [value]="fpState.input"
          (input)="updatePanelInput($any($event.target).value)"
          rows="3"
        ></textarea>
        <button class="cv__feedback-submit" (click)="submitFeedback()" [disabled]="isLoading()">
          @if (isLoading()) {
            <loader color="white" size="16px" />
          } @else {
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="19" x2="12" y2="5" />
              <polyline points="5 12 12 5 19 12" />
            </svg>
          }
        </button>
      </div>
    }
  </div>
}
